// modal.js
import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../css/Modal.css';
import axios from 'axios';
import { HotTable, HotColumn } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import styleHs from '../css/Hs.module.css';
import reloadToken from '../helper/reloadtoken';
import { apiConfig } from '../helper/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const notify_cant_update_br_cont = (message, time = 800) => {
    toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: time,
    });
  };
  
  const notify_update_br_cont = (message, time = 2000) => {
    toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: time,
    });
  };

const Modal_multi_asset = ({ modalVisible, toggleModal, data }) => {
    var title_document = ""
    const hostfile = process.env.REACT_APP_API_HOST_UPLOAD;
    const mainhost = process.env.REACT_APP_API_HOST_MASTER;
    var API_SHOW_FILE = mainhost + "AssetList"


    const [role, setRole] = useState("");
    const [namaAsset, setNamaAsset] = useState([]);
    const [assetSelected, setAssetSelected] = useState([]);
    var data_all = [];

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    useEffect(() => {
        const role = localStorage.getItem('role');
        setRole(role);
        // Call openModal when modalVisible prop is true
        if (modalVisible) {
            openModal();
        }
    }, );
    
    const fetchData = async () => {
        try {

        const token = localStorage.getItem('token');
        const config = apiConfig(token);
        const formData = new FormData();
        axios.get(`${API_SHOW_FILE}`, config)
            .then((response) => {
                console.log(response.data);
                setNamaAsset(response.data);
            })
            .catch((error) => {
                console.log(error);
            }
            );
        } catch (error) {
            //console.error("Error fetching data:", error);
        }
    };

    const selectAsset = (value) => {
        if (assetSelected.includes(value)) {
            return;
        }
        setAssetSelected([...assetSelected, value]);
    }

    const removeSelectedAsset = (value) => {
        setAssetSelected(assetSelected.filter((item) => item !== value));
    }

    useEffect(() => {
        console.log('data', data);
        setAssetSelected([]);
        if (modalVisible) {
            document.body.classList.add('active-modal');
            fetchData();
        } else {
            document.body.classList.remove('active-modal');
        }
    }, [modalVisible]);

    const updateNamaPt = (data) => {
        // setNamaPt(data);
      };

    const isDataEmpty = !data || !data.nama;


    const closeModal = () => {
        setModalIsOpen(false);
        toggleModal(); // Call the toggleModal function to close the modal
        if (role !== 'TIMKONSEP') {
           // window.location.reload();
        }
    };
    const saveModal = () => {
        console.log('assetSelected', assetSelected);
        console.log('data', data);
        const token = localStorage.getItem('token');
        const config = apiConfig(token);
        const API_Update_Multi = mainhost + "AssetUpdateAssetList";
        var datax = {};
        datax["id"] = data.id;
        datax["assetSelected"] = JSON.stringify(assetSelected);
        axios.post(`${API_Update_Multi}`, datax, config)
            .then((response) => {
                console.log(response.data);
                if (response.data.status === 200) {
                    notify_update_br_cont(response.data.message);
                }
                else {
                    notify_cant_update_br_cont(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
            }
        );

        setModalIsOpen(false);
        toggleModal(); // Call the toggleModal function to close the modal
        if (role !== 'TIMKONSEP') {
           // window.location.reload();
        }
    };


    return createPortal(
        modalVisible ? (
            <div className="modal" >
                <div onClick={closeModal} className="overlay"></div>
                <div className="modal-content-detail">
                    <h6 className="modal-title">Asset List</h6>
                    <div className="modal-body">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="col-md-6" style={{ float:'left', width:'50%'}}>
                                        <label htmlFor="nama">Nama Asset</label>
                                        <select className="form-control" id="nama" name="nama" multiple="multiple" onChange={(e) => selectAsset(e.target.value)} style={{ height:'240px'}}>
                                            {namaAsset.map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                    <div className="col-md-6" style={{ float:'left', width:'50%'}}>
                                        <label htmlFor="nama">Selected Asset</label>
                                        <select className="form-control" id="nama" name="nama" multiple="multiple" onChange={(e) => removeSelectedAsset(e.target.value)} style={{ height:'240px'}}>
                                            {assetSelected.map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="btn_close-modal bg_success" style={{ backgroundColor:'green', color:'white'}} onClick={saveModal}>
                        Oke
                    </button>
                    <button className="btn_close-modal btn_close" onClick={closeModal}>
                        Cancel
                    </button>
                </div>
            </div>
        ) : null,
        document.body
    );
};

export default Modal_multi_asset;